module.exports = __webpack_public_path__ + "static/media/ta-rpo-03.94e88d82.png";